import axios from "axios";
import { store } from "shared/redux/store/store";
import { PublicURL } from "./endpoints";

/**
 * Axios client for the SCHOOL API (`/api/`), not the admin API (`/api/admin/`).
 *
 * The head-office analytics endpoints only exist on the school API and are
 * normally answered for the logged-in school. Admin has no mirror of them, so
 * this client calls them directly with the admin's own Bearer token and scopes
 * every request to a school with `?school_id=`.
 *
 * It deliberately does NOT share the admin interceptor's 401 handling: a
 * refusal here means "admin can't read this school's analytics", which must not
 * log the admin out of the panel.
 */
export const SCHOOL_HTTP_CLIENT = axios.create({
  baseURL: PublicURL,
  timeout: 30000,
});

SCHOOL_HTTP_CLIENT.interceptors.request.use(
  (config: any) => {
    const token = store.getState().root?.user?.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (err) => Promise.reject(err)
);
